<template>
    <div class="interaction">
        <div class="list-wrap">
            <div class="tab-title">
                <span
                    @click="setTab('message')"
                    id="btn-message-list"
                    class="tab-list"
                    :class="{ active: checkActive('message') }"
                >
                    聊天
                </span>
                <span
                    @click="setTab('question')"
                    id="btn-message-list"
                    class="tab-list"
                    :class="{ active: checkActive('question') }"
                >
                    问答
                </span>
                <span
                    v-if="!isWx && liveInfo && liveInfo.webrtc === 1"
                    @click="setTab('action')"
                    id="btn-action-list"
                    class="tab-list"
                    :class="{ active: checkActive('action') }"
                >
                    发言列表
                </span>
            </div>

            <div class="tab-container">
                <!-- 用户列表 -->
                <!-- <div class="user-list" :class="{ active: checkActive('user') }">
                    <UserList />
                </div> -->
                <!-- 聊天 -->
                <div class="message-list" :class="{ active: checkActive('message') }">
                    <MessageList :liveInfo="liveInfo" />
                </div>
                <!-- 发言列表 -->
                <div
                    v-if="!isWx && liveInfo && liveInfo.webrtc === 1"
                    class="action-list"
                    :class="{ active: checkActive('action') }"
                >
                    <ActiveList />
                </div>
                <!-- 问答 -->
                <div class="message-list" :class="{ active: checkActive('question') }">
                    <QuestionAnswer />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MessageList from './MessageList'
// import UserList from './UserList'
import ActiveList from './ActiveList'
import QuestionAnswer from './QuestionAnswer'

export default {
    props: ['liveInfo'],
    components: {
        MessageList,
        // UserList,
        ActiveList,
        QuestionAnswer,
    },
    data() {
        return {
            activeTab: 'message',
            isWx: BJY.browser.wechat,
        }
    },
    computed: {},
    watch: {},
    methods: {
        setTab(tab) {
            this.activeTab = tab
        },
        checkActive(tab) {
            return tab === this.activeTab
        },
    },
    created() {
        // 这里监听一下举手被接收，切换到发言列表tab
        BJY.eventEmitter.on(BJY.eventEmitter.SPEAK_APPLY_RESULT_ACCEPT, (e, data) => {
            this.activeTab = 'action'
        })
    },
    mounted() {},
    beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
//@import url(); 引入公共css类
.interaction {
    position: absolute;
    top: 0;
    left: 12px;
    right: 12px;
    bottom: 0;
    font-size: 13px;

    .list-wrap {
        width: 100%;
        height: 100%;

        .tab-title {
            position: relative;
            display: flex;
            padding: 4px;
            user-select: none;
            background: rgba(159, 168, 181, 0.1);
            font-size: 12px;
            margin-top: 12px;
            .tab-list {
                width: 33.33%;
                position: relative;
                text-align: center;
                flex: 1;
                height: 24px;
                line-height: 24px;
                cursor: pointer !important;
                white-space: nowrap;
                color: #333;
            }
            .active {
                background: #1e5eff;
                border-radius: 3px;
                color: #fff;
            }

            .has-new {
                &:after {
                    content: '';
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: red;
                    position: absolute;
                    top: 5px;
                    right: 8px;
                }
            }
        }

        .tab-container {
            position: absolute;
            top: 54px;
            bottom: 0;
            left: 0;
            right: 0;

            .user-list,
            .message-list,
            .action-list {
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                opacity: 0;
            }

            .active {
                left: 0;
                opacity: 1;
                z-index: 1;
            }
        }
    }
}
</style>
